import * as React from 'react';
import * as I18n from 'i18n-js';
import FormGroupWithInput from '@reverbdotcom/commons/dist/components/form_group_with_input';
import FormGroupWithSelect from '@reverbdotcom/commons/dist/components/form_group_with_select';
import { IUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';
import {
  ICardData,
  ITokenizedCreditCardData,
  IBillingCardAddress,
} from './card_data';
import TokenizedCreditCardFields from './tokenized_credit_card_fields';
import { core_apimessages_Country as ICountry } from '../schemas/rql';

export interface IProps extends IUserContext {
  children?: React.ReactNode;
  onCardDataUpdate: (data: ICardData) => void;
  onTokenizedFieldUpdate: (data: Partial<ITokenizedCreditCardData>) => void;
  cardData: ICardData;
  billingCardAddress: IBillingCardAddress;
  onBillingCardAddressUpdate: (data: Partial<IBillingCardAddress>) => void;
  countries: ICountry[];
}

export default class CreateCreditCardForm extends React.Component<IProps, null> {
  getCountryOptions() {
    return this.props.countries.map((country) => {
      return {
        value: country.countryCode,
        text: country.name,
      };
    });
  }

  render() {
    return (
      <div>
        <FormGroupWithInput
          inputName="billingCardCardholderName"
          label={I18n.t('discovery.creditCardForm.nameOnCard')}
          value={this.props.cardData.cardholderName}
          updateField={this.props.onCardDataUpdate}
          fieldName="cardholderName"
          required
        />
        <TokenizedCreditCardFields
          onTokenizedFieldUpdate={this.props.onTokenizedFieldUpdate}
          onCardDataUpdate={this.props.onCardDataUpdate}
        />
        <div className="g-container">
          <div className="g-col-6 g-col-mobile-12 scaling-mb-2">
            <FormGroupWithInput
              label={I18n.t('discovery.creditCardForm.postalCode')}
              fieldName="postalCode"
              inputName="billingAddressPostalCode"
              value={this.props.billingCardAddress.postalCode}
              updateField={this.props.onBillingCardAddressUpdate}
              required
            />
          </div>
          <div className="g-col-6 g-col-mobile-12 scaling-mb-2">
            <FormGroupWithSelect
              label={I18n.t('discovery.creditCardForm.country')}
              fieldName="countryCode"
              inputName="billingAddressCountryCode"
              updateField={this.props.onBillingCardAddressUpdate}
              value={this.props.billingCardAddress.countryCode}
              required
              options={this.getCountryOptions()}
            />
          </div>
        </div>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/create_credit_card_form.tsx